export default __webpack_public_path__ + "static/media/nli-avatar.958b6b90.png";